import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConversationFlowStepResponse } from '../models/responses/conversation-flow-step-response';
import { environment } from '../environments/environments';
import { ConversationFlowStepRequest } from '../models/requests/Conversation-flow-step-request';
import { ConversationFlowArcResponse } from '../models/responses/conversational-flow-arc-response';

@Injectable({
  providedIn: 'root'
})
export class ConversationStepService {

  constructor(private httpClient: HttpClient) { }

  fetchSteps(aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.get<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/fetchForAiAgent/${aiAgentId}`);
  }

  addRootStep(step: ConversationFlowStepRequest): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addRootStep`, { step });
  }

  addChildStep(step: ConversationFlowStepRequest): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addChildStep`, { step });
  }

  updateStep(step: ConversationFlowStepRequest): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.put<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/updateStep`, { step });
  }

  deleteStep(id: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.delete<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/deleteStep/${id}/${aiAgentId}`);
  }

  createArc(arc: ConversationFlowArcResponse, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/createArc`, { arc, aiAgentId });
  }

  updateArc(arc: ConversationFlowArcResponse, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.put<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/updateArc`, { arc, aiAgentId });
  }

  addZapToStep(zapId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addZapToStep`, { zapId, conversationFlowStepId, aiAgentId });
  }
  
  removeZapFromStep(zapId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/removeZapFromStep`, { zapId, conversationFlowStepId, aiAgentId });
  }

  addCalToStep(calId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addCalToStep`, { calId, conversationFlowStepId, aiAgentId });
  }
  
  removeCalFromStep(calId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/removeCalFromStep`, { calId, conversationFlowStepId, aiAgentId });
  }
  
  addGHLToStep(ghlId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addGhlToStep`, { ghlId, conversationFlowStepId, aiAgentId });
  }
  
  removeGHLFromStep(ghlId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/removeGhlFromStep`, { ghlId, conversationFlowStepId, aiAgentId });
  }

  addGoogleSeetToStep(id: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addGoogleSheetToStep`, { googleSheetIntegrationId:id, conversationFlowStepId, aiAgentId });
  }
  
  removeGoogleSheetFromStep(googleSheetId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/removeGoogleSheetFromStep`, { ghlId: googleSheetId, conversationFlowStepId, aiAgentId });
  }

  addNotificationToStep(notificationId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addNotificationToStep`, { notificationId, conversationFlowStepId, aiAgentId });
  }
  
  removeNotificationFromStep(notificationId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/removeNotificationFromStep`, { notificationId, conversationFlowStepId, aiAgentId });
  }

  addMakeToStep(makeId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/addMakeToStep`, { makeId, conversationFlowStepId, aiAgentId });
  }
  
  removeMakeFromStep(notificationId: number, conversationFlowStepId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.post<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/removeMakeFromStep`, { notificationId, conversationFlowStepId, aiAgentId });
  }
  deleteArc(arcId: number, aiAgentId: number): Observable<ConversationFlowStepResponse[]> {
    return this.httpClient.delete<ConversationFlowStepResponse[]>(`${environment.conversationStepUrl}/deleteArc/${arcId}/${aiAgentId}`);
  }
}
